module.exports = __webpack_public_path__ + "img/last-page.260c2b26.svg";